import { useEffect, useState } from "react";
import {
  isEmbeddedFrame,
  parentResizesIframe,
  subscribeParentResizesIframe,
} from "@utils/iframeMessaging";

// False until a layout post changes the frame. Old parent pages never do.
export const useParentResizesIframe = () => {
  const [resizes, setResizes] = useState(parentResizesIframe);

  useEffect(() => {
    if (!isEmbeddedFrame()) return;
    setResizes(parentResizesIframe());
    return subscribeParentResizesIframe(setResizes);
  }, []);

  return resizes;
};
